import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_bank_reconciliation_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  filing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  amount_debit: fromDatatype.MoneyDatatypeInterface;
  amount_credit: fromDatatype.MoneyDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_bank_reconciliation_link_RowClass implements bl_fi_bank_reconciliation_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  filing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  amount_debit: fromDatatype.MoneyDatatypeInterface;
  amount_credit: fromDatatype.MoneyDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


